module.exports = __webpack_public_path__ + "static/media/R.83238bb1.svg";